export const CHAKRA_LOCAL_STORAGE_KEY = 'chakra-ui-color-mode'
